<template>
  <div class="container-box">
    <div class="search-box-2">
      <div class="form-row-1">
        <p class="label">조회 기간</p>
        <div class="write-con d-flex align-center">
          <div class="datepicker-type-1">
            <v-icon>mdi-calendar-blank</v-icon>
            <date-range-picker
              v-model="propDateRange"
              :locale-data="{
                format: 'yyyy-mm-dd',
                applyLabel: '확인',
                cancelLabel: '취소',
              }"
              opens="right"
              @update="updateDateRange"
            ></date-range-picker>
          </div>
          <div class="ml-2">
            <v-btn
              large
              depressed
              max-height="40px"
              color="#fecd06"
              min-width="104px"
              class="button-type-1"
              @click.prevent="registerMedias"
            >
              조회
            </v-btn>
          </div>
        </div>
      </div>
    </div>

    <div v-if="boardLists.length > 0" class="mt-16">
      <div class="d-flex justify-space-between">
        <h3 class="title-type-2">
          <strong>{{ mediaName }}</strong>
          매체 지면별 결과 요약
        </h3>

        <vue-json-to-csv
          :json-data="customLists"
          :csv-title="`${mediaName} 매체 지면별 결과 요약`"
        >
          <v-btn
            large
            depressed
            max-height="40px"
            color="#fecd06"
            class="button-type-1"
          >
            <v-icon left> mdi-download </v-icon>
            엑셀 다운로드
          </v-btn>
        </vue-json-to-csv>
      </div>

      <div class="table-wrap" v-if="boardLists.length > 0">
        <table class="data-table-1">
          <caption>
            데이터 테이블
          </caption>
          <colgroup>
            <col />
            <col width="190px" />
            <col width="180px" />
            <col width="340px" />
            <col width="109px" />
            <col width="109px" />
            <col width="84px" />
          </colgroup>
          <thead>
            <tr>
              <th scope="row">매체명</th>
              <th scope="row">지면명</th>
              <th scope="row">집행 기간</th>
              <th scope="row">소재 구분</th>
              <th scope="row">노출</th>
              <th scope="row">클릭</th>
              <th scope="row">CTR</th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th scope="row" colspan="4">총계</th>
              <td>{{ total.impr | comma }}</td>
              <td>{{ total.click | comma }}</td>
              <td>{{ total.ctr.toFixed(2) + '%' }}</td>
            </tr>
          </tfoot>
          <tbody>
            <tr>
              <td>
                {{ boardName }}
              </td>
              <td class="pa-0" colspan="6">
                <table style="width: 100%">
                  <colgroup>
                    <col width="190px" />
                    <col width="180px" />
                    <col width="340px" />
                    <col width="109px" />
                    <col width="109px" />
                    <col width="84px" />
                  </colgroup>
                  <tr v-for="(item, index) in boardLists" :key="index">
                    <td>
                      <a
                        href=""
                        @click.prevent="registerMediasDays(item.id, item.name)"
                      >
                        {{ item.name }}
                      </a>
                    </td>
                    <td>
                      <span v-if="item.start_at && item.end_at">
                        {{ item.start_at | moment('YYYY.MM.DD') }}
                        ~
                        {{ item.end_at | moment('YYYY.MM.DD') }}
                      </span>
                      <span v-else>-</span>
                    </td>
                    <td class="pa-0" colspan="4">
                      <table style="width: 100%">
                        <colgroup>
                          <col />
                          <col width="109px" />
                          <col width="109px" />
                          <col width="84px" />
                        </colgroup>
                        <tr v-for="(res, idx) in item.resources" :key="idx">
                          <td>{{ res.name }}</td>
                          <td>{{ res.impr | comma }}</td>
                          <td>{{ res.click | comma }}</td>
                          <td>
                            {{ res.ctr ? res.ctr.toFixed(2) + '%' : '-' }}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="detailLists.length > 0" class="mt-16">
      <div class="d-flex justify-space-between">
        <h4 class="title-type-2">
          <strong>{{ ` ${mediaName} ${detailTitle} ` }}</strong>
          지면 상세 내역
        </h4>

        <vue-json-to-csv
          :json-data="detailCustomLists"
          :csv-title="`${mediaName} ${detailTitle} 지면 상세 내역`"
        >
          <v-btn
            large
            depressed
            max-height="40px"
            color="#fecd06"
            class="button-type-1"
          >
            <v-icon left> mdi-download </v-icon>
            엑셀 다운로드
          </v-btn>
        </vue-json-to-csv>
      </div>

      <div class="table-wrap" v-if="detailLists.length > 0">
        <table class="data-table-1">
          <caption>
            데이터 테이블
          </caption>
          <colgroup>
            <col />
            <col width="360px" />
            <col width="300px" />
            <col width="109px" />
            <col width="109px" />
            <col width="84px" />
          </colgroup>
          <thead>
            <tr>
              <th scope="row">날짜</th>
              <th scope="row">소재 구분</th>
              <th scope="row">소재 게재 기간</th>
              <th scope="row">노출</th>
              <th scope="row">클릭</th>
              <th scope="row">CTR</th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th scope="row" colspan="3">소계</th>
              <td>{{ detailTotal.impr | comma }}</td>
              <td>{{ detailTotal.click | comma }}</td>
              <td>
                {{ detailTotal.ctr ? detailTotal.ctr.toFixed(2) + '%' : '-' }}
              </td>
            </tr>
          </tfoot>
          <tbody>
            <tr v-for="(item, index) in detailLists" :key="index">
              <td>
                {{ item.day }}
              </td>
              <td class="pa-0" colspan="5">
                <table style="width: 100%">
                  <colgroup>
                    <col />
                    <col width="300px" />
                    <col width="109px" />
                    <col width="109px" />
                    <col width="84px" />
                  </colgroup>
                  <tr v-for="(res, idx) in item.resources" :key="idx">
                    <td>{{ res.name }}</td>
                    <td>
                      <span v-if="res.start_at && res.end_at">
                        {{ res.start_at | moment('YYYY.MM.DD') }}
                        ~
                        {{ res.end_at | moment('YYYY.MM.DD') }}
                      </span>
                      <span v-else>-</span>
                    </td>
                    <td>{{ res.impr | comma }}</td>
                    <td>{{ res.click | comma }}</td>
                    <td>{{ res.ctr ? res.ctr.toFixed(2) + '%' : '-' }}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text">{{ logResult }}</div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="showSystemAlert = false"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker';
import SystemAlert from '~@/modal/SystemAlert.vue';
import bus from '@/utils/bus.js';
import { listMedia } from '@/api/media';
import { reportUserMediasList, reportUserMediasDaysList } from '@/api/report';
import { toISOFormattedDate } from '@/utils/validation';
import moment from 'moment';
import VueJsonToCsv from 'vue-json-to-csv';

let today = new Date();
today.setHours(0, 0, 0, 0);
today = moment(today).add(-1, 'months').subtract(1, 'days').toDate();
let today2 = moment(today).add(1, 'months');

export default {
  props: {
    id: String,
    mediaId: String,
    dateRanges: Object,
  },
  components: {
    DateRangePicker,
    SystemAlert,
    VueJsonToCsv,
  },
  data: () => ({
    dateRange: {
      startDate: today,
      endDate: today2,
    },
    mediaName: null,
    boardName: '',
    boardLists: [],
    customLists: [],
    total: {
      impr: 0,
      click: 0,
      ctr: 0,
    },

    showSystemAlert: false,
    logResult: '',

    detailTitle: '',
    detailLists: [],
    detailCustomLists: [],
    detailTotal: {
      impr: 0,
      click: 0,
      ctr: 0,
    },
  }),
  computed: {
    propDateRange: {
      get() {
        return this.dateRanges || this.dateRange;
      },
      set(value) {
        this.dateRange = value;
      },
    },
  },
  methods: {
    async registerMedias() {
      try {
        const paramsId = this.$route.params.id;

        const dateS = this.dateRanges
          ? this.dateChange
            ? this.dateRange.startDate
            : this.dateRanges.startDate
          : this.dateRange.startDate;
        const dateE = this.dateRanges
          ? this.dateChange
            ? this.dateRange.endDate
            : this.dateRanges.endDate
          : this.dateRange.endDate;

        let startDate = toISOFormattedDate(dateS);
        let endDate = toISOFormattedDate(dateE);

        bus.$emit('start:spinner');

        const resultData = {
          start_at: startDate,
          end_at: endDate,
        };

        const { data } = await reportUserMediasList(
          paramsId,
          this.mediaId,
          resultData,
        );

        if (data.list.inventories.length > 0) {
          this.mediaName = data.media.name;
          this.boardName = data.list.name;
          this.boardLists = data.list.inventories;

          const exel = [];
          const total = {
            impr: 0,
            click: 0,
            ctr: 0,
          };

          data.list.inventories.filter(lists => {
            lists.resources.forEach(res => {
              exel.push({
                매체명: data.list.name,
                지면명: lists.name,
                '집행 기간': lists.start_at
                  ? `${moment(lists.start_at).format('YYYY.MM.DD')} ~ ${moment(
                      lists.end_at,
                    ).format('YYYY.MM.DD')}`
                  : '-',
                '소재 구분': res.name,
                노출: res.impr,
                클릭: res.click,
                CTR: res.ctr ? res.ctr.toFixed(2) + '%' : '-',
              });
              total.impr = total.impr + res.impr;
              total.click = total.click + res.click;
            });
          });
          total.ctr = (total.click / total.impr) * 100;
          this.customLists = exel;
          this.total = total;
        } else {
          this.showSystemAlert = true;
          this.logResult = '조회된 목록이 없습니다.';
          this.boardLists = [];
        }
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },

    async registerMediasDays(invenID, invenName) {
      try {
        const paramsId = this.$route.params.id;

        const dateS = this.dateRanges
          ? this.dateChange
            ? this.dateRange.startDate
            : this.dateRanges.startDate
          : this.dateRange.startDate;
        const dateE = this.dateRanges
          ? this.dateChange
            ? this.dateRange.endDate
            : this.dateRanges.endDate
          : this.dateRange.endDate;

        let startDate = toISOFormattedDate(dateS);
        let endDate = toISOFormattedDate(dateE);

        bus.$emit('start:spinner');

        const resultData = {
          start_at: startDate,
          end_at: endDate,
        };

        const { data } = await reportUserMediasDaysList(
          paramsId,
          this.mediaId,
          invenID,
          resultData,
        );

        if (data.list.length > 0) {
          this.detailTitle = data.inventory.name;
          this.detailLists = data.list;

          const exel = [];
          const total = {
            impr: 0,
            click: 0,
            ctr: 0,
          };

          data.list.filter(lists => {
            lists.resources.forEach(res => {
              exel.push({
                날짜: `${moment(lists.day).format('YYYYMMDD')}`,
                '소재 구분': res.name,
                '소재 게재 기간': res.start_at
                  ? `${moment(res.start_at).format('YYYY.MM.DD')} ~ ${moment(
                      res.end_at,
                    ).format('YYYY.MM.DD')}`
                  : '-',
                노출: res.impr,
                클릭: res.click,
                CTR: res.ctr ? res.ctr.toFixed(2) + '%' : '-',
              });
              total.impr = total.impr + res.impr;
              total.click = total.click + res.click;
            });
          });
          total.ctr = (total.click / total.impr) * 100;
          this.detailCustomLists = exel;
          this.detailTotal = total;
        } else {
          this.showSystemAlert = true;
          this.logResult = '조회된 목록이 없습니다.';
          this.boardLists = [];
        }
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        const { data } = error.response;
        this.resultType = data.result;
        if (data.result === 'DuplicatedEntry') {
          this.showSystemAlert = true;
          this.logResult = '이미 사용중인 아이디가 있습니다.';
        } else if (data.result === 'ParameterValidation') {
          this.showSystemAlert = true;
          this.logResult = '등록에 실패하였습니다. 재등록 부탁드립니다.';
        } else {
          console.log(error.response);
        }
      }
    },
    updateDateRange() {
      this.dateRange.startDate.setHours(0, 0, 0, 0);
      this.dateRange.endDate.setHours(0, 0, 0, 0);
    },
  },
  created() {
    bus.$emit('start:spinner');
    this.registerMedias();
  },
};
</script>
